var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Apexcharts',{ref:"chart",class:{forceFitWidth: _vm.forceFitWidth},attrs:{"type":"heatmap","options":_vm.localOptions,"series":_vm.series,"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }